import { removeUserAndOrg } from '../../utils'

export const createUserStore = (set) => ({
	isAdmin: false,
	setIsAdmin: (isAdmin) =>
		set({ isAdmin }, false, {
			type: 'isAdmin/set',
			isAdmin
		}),
	userToken: null,
	setUserToken: (userToken) =>
		set({ userToken }, false, {
			type: 'userToken/set',
			userToken
		}),
	userTokenExpired: false,
	setUserTokenExpired: (userTokenExpired) =>
		set({ userTokenExpired }, false, {
			type: 'setUserTokenExpired/set',
			userTokenExpired
		}),
	userEmail: null,
	setUserEmail: (userEmail) =>
		set({ userEmail }, false, {
			type: 'userEmail/set',
			userEmail
		}),
	authCodeRequested: false,
	setAuthCodeRequested: (authCodeRequested = true) =>
		set({ authCodeRequested }, false, {
			type: 'authCodeRequested/set',
			authCodeRequested
		}),
	resetAuth: () => {
		removeUserAndOrg()
		set(
			{
				userToken: null,
				isAdmin: false,
				authCodeRequested: false,
				userEmail: null,
				userTokenExpired: false
			},
			false,
			{
				type: 'userToken/reset'
			}
		)
	},
	loggingOut: false,
	setLoggingOut: (loggingOut = true) =>
		set({ loggingOut }, false, {
			type: 'loggingOut/set',
			loggingOut
		})
})
